exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-widget-action[data-v-af1d4692]{display:flex;align-items:center;position:absolute;top:.5rem;right:.5rem;padding:.125rem .25rem;border-radius:.25rem;box-shadow:var(--fts-elevation-1);background-color:inherit;cursor:default}.fts-widget-action>[data-v-af1d4692]:not(:last-child){margin-right:.5rem}.widget-action-slide-fade-enter-active[data-v-af1d4692],.widget-action-slide-fade-leave-active[data-v-af1d4692]{transition:all .3s ease}.widget-action-slide-fade-enter[data-v-af1d4692],.widget-action-slide-fade-leave-to[data-v-af1d4692]{transform:translateX(.5rem);opacity:0}", ""]);

// exports
